import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { subscriptionFormActionsV2 } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormV2Sagas'
import { useSnackbar } from 'baseui/snackbar'
import {
  selectActiveAddress,
  selectCurrentAddressData,
} from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSelectors'
import useFormStatus from '@/containers/SubscriptionFormPageNew/SubscriptionForm/useFormStatus'
import { selectAuthData } from '../../../Login/AuthSelectors'

const useGasMeterSave = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { enqueue } = useSnackbar()
  const { isEditable } = useFormStatus()
  const { country } = useSelector(selectAuthData)

  const activeAddress = useSelector(selectActiveAddress)
  const { gasMeter = {} } = useSelector(selectCurrentAddressData)
  const { isSaving = false, pceEligibilityData = {}, pceNo = '', isValidPce = false } = gasMeter

  const isMeterDataReady = (Object.keys(pceEligibilityData).length > 0 || country === 'nl') && pceNo && isValidPce
  const canSave = isEditable && isMeterDataReady

  const saveGasMeter = () => {
    dispatch({
      type: subscriptionFormActionsV2.SAVE_GAS_METER_V2,
      enqueue,
      meterData: gasMeter,
      addressId: activeAddress,
    })
  }

  return {
    saveGasMeter,
    isSaving,
    isEditable,
    canSave,
    isMeterDataReady,
    t,
    gasMeter,
  }
}

export default useGasMeterSave
